interface AreaAccessPermitPDFProps {
    buildings: {
        s_LocationName_En: string;
        s_LocationName_Ar: string;
        items: {
            s_BuildingName_En: string;
            s_BuildingName_Ar: string;
        }[];
    }[];
}

const AreaAccessPermitPDF = ({ buildings }: AreaAccessPermitPDFProps) => {
    return (
        <>
            <div className="bg-white p-1 text-[10px]">
                Area Access:
            </div>
            <div >
                {buildings?.map((location) => (
                    <div key={location.s_LocationName_En}>
                        <div className="py-1">
                            <p className="px-1 text-[10px] inline-flex ">
                                <span className="font-medium">{location.s_LocationName_En}:</span> {location.items?.map((bldg, idx) => (
                                    <p key={idx} className="text-[10px] px-1">{bldg.s_BuildingName_En}, </p>
                                ))}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default AreaAccessPermitPDF
